import React from 'react';

const Performance = ({width, height, color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 14L6 10L10 12L16 6M16 6V12M16 6H10"
                stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default Performance;
